import { Link, router } from '@inertiajs/react'

export default function PendingMatchesList({ matches }) {
  if (!matches || matches.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <p>Aucun match en attente</p>
        <Link href="/matches" className="text-primary-600 hover:text-primary-700 text-sm mt-2 inline-block">
          Voir tous les matches →
        </Link>
      </div>
    )
  }

  const handleAccept = (matchId) => {
    router.post(`/matches/${matchId}/accept`)
  }

  const handleReject = (matchId) => {
    if (confirm('Êtes-vous sûr de vouloir rejeter ce match ?')) {
      router.post(`/matches/${matchId}/reject`)
    }
  }

  return (
    <div className="space-y-3">
      {matches.map((match) => (
        <div
          key={match.id}
          className="p-3 rounded-lg border border-gray-200 hover:border-primary-300 transition-colors"
        >
          <div className="flex items-start justify-between mb-2">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <h4 className="font-medium text-gray-900">
                  {match.lead.first_name} {match.lead.last_name}
                </h4>
                {!match.internal_match && (
                  <span className="px-2 py-0.5 text-xs font-medium rounded bg-purple-100 text-purple-800">
                    Réseau
                  </span>
                )}
              </div>
              <p className="text-sm text-gray-600 mb-1">{match.property.title}</p>
              <div className="flex items-center gap-3 text-xs text-gray-500">
                <span>Score: {match.relevance_score}/100</span>
                {!match.internal_match && match.commission_split && (
                  <>
                    <span>•</span>
                    <span>
                      Commission: {match.commission_split.source}/{match.commission_split.target}
                    </span>
                    <span>•</span>
                    <span>{match.target_agency.name}</span>
                  </>
                )}
              </div>
            </div>
            <div className="flex items-center gap-2 ml-4">
              <button
                onClick={() => handleAccept(match.id)}
                className="px-3 py-1 text-xs font-medium text-white bg-green-600 rounded hover:bg-green-700 transition-colors"
              >
                Accepter
              </button>
              <button
                onClick={() => handleReject(match.id)}
                className="px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded hover:bg-gray-200 transition-colors"
              >
                Rejeter
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
